export default __webpack_public_path__ + "static/media/bugherd.9f957f4c.svg";